


















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import debounce from 'lodash.debounce';
import { Route } from 'vue-router';
import {
  ClientDTO,
  ClientFilterDTOTypeEnum,
  GetClientsRequestSortByEnum,
  GetClientsRequestSortOrderEnum,
  GetClientsRequest,
  GetClientsRequestClientTypeEnum,
} from '@/api';
import services from '@/services';
// import { createScroller } from '@/utils';
import { authModule, clientsModule } from '@/store';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';

@Component({
  name: 'clients',
  components: {
    UserMenu,
    MainNavbar,
  },
})
export default class Clients extends Vue {
  loading = false;

  total: number | null = null;

  clients: ClientDTO[] = [];

  client: ClientDTO | null = null;

  statusList: { [key: string]: string } = {};

  searchString: string = '';

  // scroller: { remove: () => void } | null = null;

  debouncedSearch = debounce(this.search, 500);

  params: GetClientsRequest = {
    offset: 0,
    length: 30,
    clientType: GetClientsRequestClientTypeEnum.CONCIERGE,
  };

  beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    this.setParams(to);
    this.fetchUsers();
    next();
  }

  async created() {
    this.setParams(this.$route);
    clientsModule.fetchStylists();
    services
      .clientsService()
      .clientEndpointStatusList()
      .then(r => r.data)
      .then((statuses) => {
        this.statusList = statuses;
      });
    this.fetchUsers();
  }

  get user() {
    return authModule.whoIam;
  }

  get stylists() {
    return clientsModule.stylists;
  }

  get stylistId() {
    return this.$route.query.STYLIST ? this.$route.query.STYLIST : 'all';
  }

  // mounted() {
  //   this.scroller = createScroller(
  //     () => ({
  //       loading: this.loading,
  //       total: this.total,
  //       count: this.clients.length,
  //     }),
  //     this.scrollPage,
  //   );
  // }

  setParams(to: Route) {
    const filters = [];
    if (to.query.STYLIST) {
      filters.push({
        type: ClientFilterDTOTypeEnum.STYLIST,
        ids: Array.isArray(to.query.STYLIST)
          ? (to.query.STYLIST as string[])
          : ([to.query.STYLIST]),
      });
    }
    if (to.query.STATUS) {
      filters.push({
        type: ClientFilterDTOTypeEnum.STATUS,
        ids: Array.isArray(to.query.STATUS)
          ? (to.query.STATUS as string[])
          : ([to.query.STATUS]),
      });
    }
    this.params = {
      ...this.params,
      offset: to.query.page ? Number(to.query.page) * 30 - 30 : 0,
      filters,
      sortBy: to.query.sortBy
        ? (to.query.sortBy as GetClientsRequestSortByEnum)
        : GetClientsRequestSortByEnum.CREATED_AT,
      sortOrder: to.query.sortOrder
        ? (to.query.sortOrder as GetClientsRequestSortOrderEnum)
        : GetClientsRequestSortOrderEnum.DESC,
      clientType: (to.query.type as GetClientsRequestClientTypeEnum) || this.params.clientType,
    };
  }

  get currentPage() {
    return ((this.params.offset || 0) + 30) / 30;
  }

  onPageChange(page: number) {
    this.$router.push({ query: { ...this.$route.query, page: String(page) } });
  }

  // scrollPage() {
  //   this.params.offset = (this.params.offset || 0) + 50;
  //   this.fetchUsers();
  // }

  search(search: string) {
    if (search.length > 2) {
      this.params.offset = 0;
      this.params.searchStr = search;
    } else {
      this.params.searchStr = undefined;
    }
    this.fetchUsers();
  }

  @Watch('searchString')
  async onSearchChange(value: string) {
    this.debouncedSearch(value);
  }

  async fetchUsers() {
    this.loading = true;
    try {
      const { data } = await services
        .clientsService()
        .clientEndpointGetClients(this.params);
      this.clients = data.clients || [];
      this.total = data.count || null;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      this.loading = false;
    }
  }

  selectStylist(id: string | 'all') {
    if (id !== 'all') {
      this.$router.push({
        query: { ...this.$route.query, STYLIST: String(id), page: undefined },
      });
    } else {
      this.$router.push({
        query: { ...this.$route.query, STYLIST: undefined, page: undefined },
      });
    }
  }

  selectClientType(type: GetClientsRequestClientTypeEnum) {
    this.$router.push({
      query: { ...this.$route.query, type, page: undefined },
    });
  }

  getSortParam(key: string) {
    switch (key) {
      case 'surname':
        return GetClientsRequestSortByEnum.SURNAME;
      case 'thingsCount':
        return GetClientsRequestSortByEnum.THINGS_COUNT;
      case 'looksCount':
        return GetClientsRequestSortByEnum.LOOKS_COUNT;
      case 'createdAtMillis':
        return GetClientsRequestSortByEnum.CREATED_AT;
      default:
        return null;
    }
  }

  setSorting({ prop, order }: { prop: string; order: string }) {
    const sortBy = this.getSortParam(prop);
    if (sortBy && order) {
      const sortOrder: GetClientsRequestSortOrderEnum = order === 'ascending'
        ? GetClientsRequestSortOrderEnum.ASC
        : GetClientsRequestSortOrderEnum.DESC;
      this.$router.push({
        query: {
          ...this.$route.query, sortBy, sortOrder, page: undefined,
        },
      });
    } else {
      this.$router.push({
        query: {
          ...this.$route.query,
          sortBy: undefined,
          sortOrder: undefined,
          page: undefined,
        },
      });
    }
  }
}
